import { render, staticRenderFns } from "./SICChooseBox.vue?vue&type=template&id=331b5155&scoped=true&"
import script from "./SICChooseBox.vue?vue&type=script&lang=js&"
export * from "./SICChooseBox.vue?vue&type=script&lang=js&"
import style0 from "./SICChooseBox.vue?vue&type=style&index=0&id=331b5155&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331b5155",
  null
  
)

export default component.exports